import { baseShadowStyle } from '../../../shared/style/base-shadow';
import { COLORS } from '../../../shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 20px;
    border-radius: 20px;
    background-color: ${COLORS.neutral_00};
    ${baseShadowStyle}
`;

export const Header = styled('div')`
    display: flex;
    align-items: center;
`;

export const Title = styled('div')`
    display: flex;
    align-items: center;
    gap: 16px;
    flex-grow: 1;
`;

export const Content = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 20px;
`;

export const List = styled('ul')`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
